import { jsx as _jsx } from "react/jsx-runtime";
import { BlogProvider } from "../context/BlogContext";
import { BlogPost } from "./BlogPost";
export const BlogPostPreview = ({ page, preload, isPreview }) => {
    return (_jsx(BlogProvider, { children: _jsx(BlogPost, { page: page, preload: preload, isPreview: isPreview }) }));
};
